module.exports = {"410307004":"首阳山街道","410307005":"商城街道","410307006":"槐新街道","410307007":"伊洛街道","410307103":"翟镇镇","410307104":"岳滩镇","410307105":"顾县镇","410307106":"缑氏镇","410307107":"府店镇","410307108":"高龙镇","410307109":"山化镇","410307110":"大口镇","410307111":"邙岭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410307.json
// module id = 1662
// module chunks = 0